import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("villa_alam_token");
        if (!token) {
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => setAdmin(r.data))
            .catch(() => localStorage.removeItem("villa_alam_token"))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const r = await api.post("/auth/login", { email, password });
        localStorage.setItem("villa_alam_token", r.data.access_token);
        setAdmin({ email: r.data.email });
        return r.data;
    };

    const logout = () => {
        localStorage.removeItem("villa_alam_token");
        setAdmin(null);
    };

    return (
        <AuthCtx.Provider value={{ admin, login, logout, loading }}>
            {children}
        </AuthCtx.Provider>
    );
};

export const useAuth = () => useContext(AuthCtx);
